import React, {useEffect,useState, useReducer, FormEvent} from 'react';
import {Link} from "react-router-dom";
import useGoogleCaptcha from '../../components/useReCaptcha.js';

import FlashMessages from '../../components/flashMessages.js';
import {SuggestTechnologyPageResult} from '../../../../server/routes/suggest-technology.js'

interface SuggestTechnologyProps {
    server: string;
    pageData: unknown;
}

interface SuggestFormProps {
    reCaptchaSiteKey: string;
    props: SuggestTechnologyPageResult;
    google: wts_approved_any;
}

interface ErrorState {
    title: string;
    description: string;
    active: boolean;
}

interface SuggestFormState {
    error: ErrorState;
}
// TODO: move API responses into a shared code
interface ApiResponse {
    success?: boolean;
    errors?: Array<{ msg: string }>;
}

type SuggestFormAction = 
    | ["error", { title?: string; description?: string; active?: boolean }]
    | ["success", { title?: string; description?: string; active?: boolean }];

export default function SuggestTechnology({server, pageData}: SuggestTechnologyProps) {

    const typedPageData = pageData as SuggestTechnologyPageResult;
	let [data, setData] = useState(typedPageData);
    const google = useGoogleCaptcha();

	return (
        <>
             <section className="section section-lg">
                <div className="container">
                    <div className="row row-50">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <h3 className="text-left mb-3">
                                <b>
                                    Suggest a technology
                                </b>
                             </h3>
If our dataset is missing a technology then you can suggest it to us, and we’ll be happy to add it and expand our detections. 
Be aware that we are adding only well established technologies, and not every suggestion is approved and added to our detection list.
Please fill out the form below to provide required information that will help us create detection methods and 
provide a technology description for our users.
                       </div>
                    </div>    
                    <div className="row row-50">
                        <div className="col-md-8 col-lg-8 col-xl-8">
                            <SuggestForm    
                                props={data}
                                reCaptchaSiteKey={data.ReCaptchaSiteKey}
                                google={google}
                                /> 
                        </div>
                    </div>       
                </div> 
            </section>
   
        </>
    )
}



const SuggestFormReducer = function( state: SuggestFormState, [ type, data ]: SuggestFormAction ): SuggestFormState {
    if( type === "error" ){
		return {
			...state,
			error: {
				title: data.title || "",
				description: data.description || "",
				active: data.active === undefined ? true : data.active
			}
		};
	};   
    if( type === "success" ){
		return {
			...state,
			error: {
				title: data.title || "",
				description: data.description || "",
				active: data.active === undefined ? true : data.active
			}
		};
	};
    return state; 
};

function SuggestForm({reCaptchaSiteKey, props, google}: SuggestFormProps) {
    const [ state, dispatch ] = useReducer( SuggestFormReducer, {
        error: { title: "", description: "", active: false }
      
    });
    useEffect(() => { 
		return () => {
			let script = document.getElementById('googleCaptchaScript');
			if (script) {
				script.remove();
			}
		}				
	},[google])       
    function SendMessage ( tech: string, category: string, desc: string, domain: string, name: string, email: string, captcha: string){
        var requestBody = JSON.stringify({
                tech, category, desc, domain, name, email, captcha
            });
    
        fetch( "/suggest-technology/sendmessage", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: requestBody
        }).then(( result: Response ) => {
            return result.json();
        }).then(( data: ApiResponse ) => {
            if (data.success) { 
                console.log(JSON.stringify(data));
                dispatch([ "success", {
                    title: "Technology submitted",
                    description: "Thank you for suggesting a new technology"
                }]);  
            } else {
                console.log(JSON.stringify(data));
                var msg = "Unknown error"
                if (data.errors && data.errors.length > 0)
                {
                    msg = data.errors[0].msg
                }
                dispatch([ "error", {
                    title: "Failed to send a message",
                    description: msg
                }]);  
            }
            grecaptcha.reset();
    
        }).catch(( e ) => {
            console.error( "Exception", e );
        });
    
    };   
    function handleSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault()
        const captcha = grecaptcha.getResponse();
        const form = event.currentTarget;
        
        const techElement = form.elements.namedItem('tech') as HTMLInputElement;
        const categoryElement = form.elements.namedItem('category') as HTMLInputElement;
        const descElement = form.elements.namedItem('desc') as HTMLTextAreaElement;
        const domainElement = form.elements.namedItem('domain') as HTMLInputElement;
        const nameElement = form.elements.namedItem('name') as HTMLInputElement;
        const emailElement = form.elements.namedItem('email') as HTMLInputElement;
        
        SendMessage(
            techElement.value,
            categoryElement.value,
            descElement.value,
            domainElement.value,
            nameElement.value,
            emailElement.value,
            captcha)
      }
    return (      
        <>    
        <div className={ "error" + (state.error.active ? " " : " hidden") }>
        <div className={ "error-close" } onClick={() => dispatch([ "error", { active: false } ]) }>X</div>
        <div className={ "error-title" }>{ state.error.title }</div>
        <div className={ "error-description" }>{ state.error.description }</div>
    </div>   
        <form action="/suggest-technology" method="POST" onSubmit={handleSubmit} >
            <div className="form-group">
                <FlashMessages props={props} />
            </div>
            <div className="form-group">
            <input
                    type="text"
                    id="tech"
                    name="tech"
                    className="form-control"
                    aria-label="Technology Name"
                    placeholder="Technology Name"
                    required
                />                
            </div>
            <div className="form-group">
            <input
                    type="text"
                    id="category"
                    name="category"
                    className="form-control"
                    aria-label="Enter technology category"
                    placeholder="Suggest a technology category"
                />                
            </div>
            <div className="form-group">
            <textarea
                    id="desc"
                    name="desc"
                    className="form-control"
                    aria-label="Provide description of the technology"
                    placeholder="Describe the technology"
                    rows={4} cols={50}
                    required
                />                
            </div>
            <div className="form-group">
            <input
                    type="domain"
                    id="domain"
                    name="domain"
                    className="form-control"
                    aria-label="Please provide example of websites that use the technology"
                    placeholder="Provide several websites that use the technology"
                    required
                />                
            </div>            
            <div className="form-group">
            <input
                    type="name"
                    id="name"
                    name="name"
                    className="form-control"
                    aria-label="Please provide Name"
                    placeholder="Your Name"
                 />                
            </div>           
            <div className="form-group">
            <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control"
                    aria-label="Please provide your email, so we can ask questions and notify you when technology will be added"
                    placeholder="Your Email"
                    required
                />                
            </div>
            <div className="form-group" style={{ display: "flex" }}>
                            <div style={{ marginLeft: 'auto'}}
                                className="g-recaptcha" 
                                id="captcha1"
                                data-sitekey={reCaptchaSiteKey}>
                            </div>
            </div>   
            <div className="form-group" style={{ display: "flex" }}>
               <button type="submit" className="btn btn-primary text-right" style={{ marginLeft: "auto" }} >Submit</button>
            </div>
        </form>        
    </>
   )
}

